import React, { useState, useEffect } from "react";
import PromotionOneWalletModal from "../../../pages/PromotionOneWalletModal";
import { Button, Col, Input, Modal, Select, Spin } from "antd";
import { applyCampaign } from "../../../data/wallet";
import { useDispatch, useSelector } from "react-redux";
import { piwikBonus } from "../../../actions/piwikUtil";
import AssignedClaimCancelForm from "./AssignedClaimCancelForm";
import { showErrorToast, showSuccessToast } from "../../../actions/helper";
import { promotionActions } from "../../../store/promotionSlice";
function AssignedClaimToStartForm({ handleClose, item, visible, ...props }) {
    const [memberInfo, setMemberInfo] = useState(
        JSON.parse(localStorage.getItem("memberInfo")) || {}
    );
    const [selectedProductGroup, setSelectedProductGroup] = useState(undefined);
    const [selectedProductGroupInfo, setSelectedProductGroupInfo] =
        useState(undefined);
    const [bonusInfo, setBonusInfo] = useState({});
    const [errorMessage, setErrorMessage] = useState("");
    const [apiError, setApiError] = useState({});
    const [showErorModal, setShowErrorModal] = useState(false);
    const [modalProps, setModalProps] = useState({});
    const [apiLoading, setApiLoading] = useState(false);
    const [showCancelForm, setShowCancelForm] = useState(false);
    const [data, setData] = useState({});
    const userCenter = useSelector((state) => state.userCenter);
    const dispatch = useDispatch();
    console.log("userCenteruserCenter", userCenter);
    useEffect(() => {
        console.log("Member Info:", memberInfo);
        console.log("AssignedClaimToStartFormFormprops:", props);
    }, [memberInfo?.userName]);

    useEffect(() => {
        if (props) {
            setBonusInfo(item?.bonus);
            if (item?.productGroups?.length === 1) {
                setSelectedProductGroup(item?.productGroups[0]?.productGroup);
                setSelectedProductGroupInfo(item?.productGroups[0]);
            }
        }
    }, [item?.participantId]);
    useEffect(() => {
        setErrorMessage("");
    }, [selectedProductGroup]);

    const handleSelectChange = (value) => {
        let selectedGroup = item.productGroups.find(
            (item) => item?.productGroup === value
        );
        setSelectedProductGroup(value);
        setSelectedProductGroupInfo(selectedGroup);

        console.log("Selected Product Group:", selectedGroup);
    };

    const handleSubmitForm = async () => {
        console.log("AssignedClaimToStartForm", props);
        setApiLoading(true);
        applyCampaign(item?.participantId, selectedProductGroup).then(
            (resp) => {
                if (applyCampaign.isStarting(resp)) {
                    console.log("Campaign is starting");
                    setErrorMessage("");
                    handleClose();
                    showSuccessToast(resp?.result?.message);
                    dispatch(promotionActions.setPromotionSecondLayerTab("2"))
                } else {
                    setApiLoading(false);
                    console.log("Campaign is not starting");
                    if (resp?.result?.errorCode === "CP30011") {
                        if (resp?.result?.data) {
                            setData(resp?.result);
                        }
                        setShowCancelForm(true);
                        return;
                    } else if (resp?.result?.errorCode === "CP30020") {
                        let errorTxt = resp?.result?.message !== "" ? resp?.result?.message : "Yêu cầu doanh thu chưa được hoàn thành. Vui lòng chờ cho đến khi hoàn thành trước khi bắt đầu chương trình khuyến mãi.";
                        setErrorMessage(errorTxt)
                        return;
                    } else if (resp?.result?.errorCode === "CP30018") {
                        let errorTxt = resp?.result?.message !== "" ? resp?.result?.message : "Bạn đã đăng ký chương trình khuyến mãi này.";
                        setErrorMessage(errorTxt);
                        return;
                    } else if (
                        ["CP30021", "CP30014", "CP30015", "CP30003"].includes(
                            resp?.result?.errorCode
                        )
                    ) {
                        let err = handleWaitToStatyErrorCode(resp?.result);
                        if (err?.showModal) {
                            setApiError(err?.config);
                            setShowErrorModal(true);
                        }
                    } else {
                        handleClose();
                        showErrorToast();
                    }
                }
            }
        );
    };

    return (
        <Modal visible={visible} footer={null} closable={false} width={426}>
            <div className="PromotionManualPromotionApplicationForm">
                <Spin spinning={apiLoading}>
                    <div className="PromotionManualPromotionApplicationForm">
                        <span
                            onClick={() => {
                                handleClose();
                            }}
                            style={{
                                position: "absolute",
                                top: "15px",
                                right: "-3px",
                                zIndex: "10",
                                cursor: "pointer",
                            }}
                        >
                            <img
                                src="/vn/img/1wallet/00/ModalCloseIcon.svg"
                                alt="Close Icon"
                            />
                        </span>
                        <Col
                            style={{
                                display: "flex",
                                justifyContent: "center",
                                marginBottom: "15px",
                            }}
                        >
                            <div
                                style={{
                                    marginTop: "55px",
                                    textAlign: "center",
                                    fontSize: "20px",
                                    fontWeight: "600",
                                    color: "#222222",
                                }}
                            >
                                Chi tiết Khuyến mãi
                            </div>
                        </Col>
                        <Col
                            style={{
                                display: "flex",
                                justifyContent: "flex-start",
                                marginBottom: "15px",
                            }}
                        >
                            <div
                                style={{
                                    textAlign: "center",
                                    fontSize: "14px",
                                    fontWeight: "400",
                                    color: "#222222",
                                }}
                            >
                                Tích lũy Doanh thu hiệu quả dựa trên danh mục
                                trò chơi này
                            </div>
                        </Col>
                        <Col
                            style={{
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "flex-start",
                                marginBottom: "15px",
                            }}
                        >
                            <div
                                style={{
                                    textAlign: "start",
                                    fontSize: "16px",
                                    fontWeight: "600",
                                    color: "#222222",
                                    width: "100%",
                                }}
                            >
                                Danh mục Trò chơi
                            </div>
                            {Array.isArray(item?.productGroups) &&
                            item?.productGroups?.length === 1 ? (
                                <Input
                                    // addonBefore={"Tên Đăng Nhập"}
                                    className="PromotionManualPromotionApplicationForm-email"
                                    value={item?.productGroups[0]?.name}
                                    disabled
                                />
                            ) : (
                                <Select
                                    id="productGroupOWAssignedClaimToStartForm"
                                    className={`AssignedClaimToStartForm-select ${!selectedProductGroup ? "has-placeholder" : ""}`}
                                    style={{ width: "100%"}}
                                    onChange={handleSelectChange}
                                    value={selectedProductGroup || undefined}
                                    placeholder="Chọn danh mục trò chơi"
                                    allowClear
                                >

                                    {/* Render the actual product groups, excluding the placeholder */}
                                    {item?.productGroups?.map((option, index) => (
                                            <Select.Option
                                                id="productGroupOWAssignedClaimToStartFormSelect"
                                                className="AssignedClaimToStartForm-select-option"
                                                key={index}
                                                value={option.productGroup}
                                            >
                                                {option.name}
                                            </Select.Option>
                                        ))}
                                </Select>
                            )}
                            <div>
                                {!!errorMessage && (
                                    <div
                                        style={{
                                            color: "#EB2121",
                                            fontSize: "12px",
                                            fontWeight: "400",
                                            marginTop: "5px",
                                            paddingLeft: "5px",
                                        }}
                                    >
                                        {errorMessage}
                                    </div>
                                )}
                            </div>
                        </Col>
                        <Col
                            style={{
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "flex-start",
                                marginBottom: "15px",
                            }}
                        >
                            <div
                                style={{
                                    textAlign: "center",
                                    fontSize: "16px",
                                    fontWeight: "600",
                                    color: "#222222",
                                }}
                            >
                                Thưởng trả sau
                            </div>
                            <Input
                                // addonBefore={"Tên Đăng Nhập"}
                                className="PromotionManualPromotionApplicationForm-email"
                                defaultValue={0}
                                value={item?.givenAmount}
                                disabled
                            />
                        </Col>
                        <Col
                            style={{
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "flex-start",
                                marginBottom: "15px",
                            }}
                        >
                            <div
                                style={{
                                    textAlign: "center",
                                    fontSize: "16px",
                                    fontWeight: "600",
                                    color: "#222222",
                                }}
                            >
                                Doanh thu yêu cầu
                            </div>
                            <Input
                                // addonBefore={"Tên Đăng Nhập"}
                                className="PromotionManualPromotionApplicationForm-phone"
                                // defaultValue={neededTurnover}
                                value={
                                    item?.productGroups?.length === 1
                                        ? item?.productGroups[0]?.turnoverAmount
                                        : selectedProductGroupInfo
                                        ? selectedProductGroupInfo?.turnoverAmount
                                        : 0
                                }
                                disabled
                            />
                        </Col>
                        <Col className="PromotionManualPromotionApplicationForm-submit-container application-form">
                            <Button
                                style={{
                                    color: "#FFFFFF",
                                    backgroundColor: "#00A6FF",
                                }}
                                className="PromotionManualPromotionApplicationForm-submit"
                                // disabled={userInputAmount === 0}
                                disabled={apiLoading}
                                onClick={() => {
                                    // handleClose();
                                    Pushgtagdata(
                                        "Promotion",
                                        "Submit Promotion Form",
                                        "Promotion_S_Application",
                                        false,
                                        [
                                            {
                                                customVariableKey: `Promotion_S_Application_PromoName_PrmoID`,
                                                customVariableValue: `${item?.promoTitle}_${item?.promoId}`,
                                            },
                                        ]
                                    );
                                    handleSubmitForm();
                                }}
                            >
                                Xác nhận
                            </Button>
                        </Col>
                        <Col className="PromotionManualPromotionApplicationForm-submit-container application-form">
                            <Button
                                style={{
                                    marginTop: "10px",
                                    color: "#00A6FF",
                                    backgroundColor: "#FFFFFF",
                                    border: "1px solid #00A6FF",
                                }}
                                className="PromotionManualPromotionApplicationForm-submit"
                                onClick={() => {
                                    handleClose();
                                    // handleSubmitForm();
                                }}
                            >
                                Quay lại
                            </Button>
                        </Col>
                        <PromotionOneWalletModal
                            isVisible={showErorModal}
                            config={apiError}
                            onClose={() => {
                                setShowErrorModal(false);
                                setApiError({});
                                setModalProps({});
                            }}
                            props={modalProps}
                        />
                        <AssignedClaimCancelForm
                            visible={showCancelForm}
                            handleClose={() => setShowCancelForm(false)}
                            item={item}
                            data={data}
                        />
                    </div>
                </Spin>
            </div>
        </Modal>
    );
}

export default AssignedClaimToStartForm;
